import { useMutation } from '@tanstack/react-query';
import { Promotion } from 'api/types';
import { Axios } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { raise } from 'helpers/raise';

export type UpdatePromotionMutationVariables = Partial<Omit<Promotion, 'id' | 'texts'>> & { texts?: Partial<Promotion['texts'][number]>[] };

export function useUpdatePromotionMutation(promotionId?: number) {
  const axios = useAxios();
  return useMutation({
    mutationKey: ['UpdatePromotion', promotionId],
    mutationFn: (promotion: UpdatePromotionMutationVariables) =>
      updatePromotion(axios, promotionId ?? raise(`UpdatePromotionMutation cannot be called without promotionId!`), promotion),
  });
}

function updatePromotion(axios: Axios, promotionId: number, promotion: UpdatePromotionMutationVariables) {
  return axios.put(`/op/v1/promotion/${promotionId}`, promotion);
}
